import { Component } from '@angular/core';

@Component({
  selector: 'app-section-banner',
  templateUrl: './section-banner.component.html',
  styleUrls: ['./section-banner.component.scss'],
})
export class SectionBannerComponent {}
